<template>
  <div class="preview">
    <UiBadge
      v-if="badgeProps"
      class="preview__badge"
      :type="badgeProps.type"
      :icon-left="badgeProps.iconLeft"
      size="medium"
      :text="badgeProps.text"
    />
    <UiText
      class="preview__value"
      tag="h2"
      :font="{ default: 'hero-display-5', tablet: 'hero-display-4' }"
      color="typography-title01"
      align-center
      :text="bonus.textBonus"
    />
    <UiText
      class="preview__min-dep"
      font="body-text-small"
      color="tabs-darken-text-color-default"
      :text="bonus.textMinDep"
    />
    <UiBtn
      class="preview__btn"
      :text="$tc('choose')"
      color="primary"
      full-width
      size="l"
      :data-gtm-id="$options.static.GTM_REG_BONUS.ID.ga_deposit_click_btn_continue"
      data-id="register-bonus"
      @click="$emit('to-cashbox')"
    />
  </div>
</template>
<script>
import { GTM_REG_BONUS } from '~/constants/gtm'

export default {
  name: 'PreviewCard',
  props: {
    bonus: { type: Object, required: true },
  },
  static: { GTM_REG_BONUS },
  computed: {
    badgeProps() {
      if (this.bonus.isTop) return {
        iconLeft: 'common/like',
        text: this.$t('regAuthForgot.regBonus.top'),
        type: 'secondary',
      }
      else if (this.bonus.isVip) return {
        iconLeft: 'common/vip',
        text: 'VIP',
        type: 'secondary',
      }
      else if (this.bonus.isPromocodeBonus) return {
        iconLeft: 'common/tag',
        text: this.$t('regAuthForgot.regBonus.byPromocode'),
        type: 'warning',
      }
      return undefined
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped />
